module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Server_16"],"path":[{"$":{"d":"M16,4V0H0V4H1V6H0v4H1v2H0v4H16V12H15V10h1V6H15V4ZM1,1H3V2H1ZM1,7H3V8H1Zm2,7H1V13H3Zm10-2H3V10H13Zm0-6H3V4H13Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Server_16.svg
// module id = 9hDd
// module chunks = 1